export const APP = {
  API_URL: process.env.VUE_APP_API_URL,
};

export const ROLES = {
  USER: "ROLE_USER",
  ORGANISATION_ADMIN: "ROLE_COMPANY_ADMIN",
  ADMIN: "ROLE_ADMIN",
};

export const STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  DECLINED: "declined",
};
